import styled from 'styled-components';

// display: flex keeps this a transparent flex item so the button inside
// still stretches to the TopNav's full height, same as the adjacent user menu.
export const MenuTriggerWrapper = styled.div`
  display: flex;
`;
